var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "graph-container bg-white" },
    [
      _c("DateRangePicker", {
        staticClass: "mb-3",
        class: { "w-100": _vm.isMobile },
        attrs: {
          opens: "right",
          ranges: _vm.customRange,
          maxDate: _vm.maxDate,
          "append-to-body": true,
          "locale-data": _vm.localeData,
        },
        on: { update: _vm.updateRange },
        model: {
          value: _vm.dateRange,
          callback: function ($$v) {
            _vm.dateRange = $$v
          },
          expression: "dateRange",
        },
      }),
      _vm._v(" "),
      _vm.data.datasets.length > 0
        ? _c("ChartLine", {
            staticClass: "line-chart-container",
            attrs: {
              width: 800,
              height: _vm.isMobile ? 800 : 320,
              data: _vm.data,
              chartOptions: _vm.options,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }